import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'open_with_faire-faire_academy_guide_chapter-view';

/**
 * Event fired on faire academy guide chapter view
 */
export function trackOpenWithFaireFaireAcademyGuideChapterView(
  User_State: string,
  Guide_Name2: string,
  Chapter_Name3: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { User_State, Guide_Name2, Chapter_Name3 },
  });
}
